import React from 'react'
import {
    Table,
} from '@material-ui/core';
import InfiniteScroll from 'react-infinite-scroller';

const PAGE_SIZE = 20;


class InfiniteScrollTable extends React.Component {

    loadMore() {
        this.props.getRowsFromServer(PAGE_SIZE);
    }

    render() {

        return(
            <Table className={this.props.className}>
                {this.props.genTableHeader()}
                <InfiniteScroll
                    hasMore={this.props.hasMore}
                    element="tbody"
                    loader={<tr className="loader" key={0}><td>Loading ...</td></tr>}
                    loadMore={(page) => {
                        this.loadMore(page)
                    }}>
                    {this.props.rowRender()}
                </InfiniteScroll>
            </Table>
        )
    }
}

export default InfiniteScrollTable;